import {all, takeEvery} from 'redux-saga/effects'

import BarcodeLabelModal from '../../ProductListPage/Modals/BarcodeLabelModal.js'
import CreatePOModal from '../../ProductListPage/Modals/CreatePOModal/index.js'
import GoodsReceiptModal from './GoodsReceiptModal/index.js'
import AddPOCommentModal from './AddPOCommentModal.js'
import CancelPOModal from './CancelPOModal.js'
import EditPOItemModal from './EditPOItemModal.js'
import GoodsReceiptTextFieldModal from './GoodsReceiptTextFieldModal.js'
import MarkAsSentModal, {
  MARK_AS_SENT,
  markAsSentWorker,
} from './MarkAsSentModal.js'
import POIDModal, {SAVE_PO_ID, savePOIDWorker} from './POIDModal.js'
import PORestockLocationModal, {
  SAVE_PO_RESTOCK_LOCATION,
  savePORestockLocationWorker,
} from './PORestockLocationModal.js'
import POTextFieldModal, {
  SAVE_PO_TEXT_FIELD,
  savePOTextFieldWorker,
} from './POTextFieldModal.js'
import RemovePOItemModal, {
  removePOItemWorker,
  REMOVE_PO_ITEM,
} from './RemovePOItemModal.js'
import SendToSupplierModal from './SendToSupplierModal.js'

export default function Modals() {
  return (
    <>
      <BarcodeLabelModal />
      <CreatePOModal />
      <GoodsReceiptModal />
      <AddPOCommentModal />
      <CancelPOModal />
      <EditPOItemModal />
      <GoodsReceiptTextFieldModal />
      <MarkAsSentModal />
      <POIDModal />
      <PORestockLocationModal />
      <POTextFieldModal />
      <RemovePOItemModal />
      <SendToSupplierModal />
    </>
  )
}

export function* purchaseOrderListModalSagas() {
  yield all([
    takeEvery(MARK_AS_SENT, markAsSentWorker),
    takeEvery(SAVE_PO_ID, savePOIDWorker),
    takeEvery(SAVE_PO_TEXT_FIELD, savePOTextFieldWorker),
    takeEvery(SAVE_PO_RESTOCK_LOCATION, savePORestockLocationWorker),
    takeEvery(REMOVE_PO_ITEM, removePOItemWorker),
  ])
}
